import settings from '@/settings'

let cadastrarSmartlock = (pin, headers) => {
  return fetch(`${settings.fisioApi}/admin/cadastrarsmartlock/`, {
    method: 'PUT',
    body: JSON.stringify({
      pin: pin
    }),
    mode: 'cors',
    headers: headers
  })
}

const PegarRelatorio = (headers) =>{
    let url = `${settings.fisioApi}/admin/Relatorio-ativos/`
    return fetch(url,{
        method: 'GET',
        mode: 'cors',
        cache: 'default',
        headers: headers
    })
}

const verificarAdmin = (headers, email) => {
      return fetch(`${settings.fisioApi}/admin/verificar-admin/?email=${email}`, {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          headers: headers
      })
  }

const listarEspecialidades = (headers) => {
    return fetch(`${settings.fisioApi}/admin/cadastrar-especialidade/`, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
  }

const cadastrarEspecialidade = (nome, headers) => {
    return fetch(`${settings.fisioApi}/admin/cadastrar-especialidade/`, {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify({
        nome: nome
      })
    })
  }

const cadastrarAdministrador = (email, headers) => {
    return fetch(`${settings.fisioApi}/admin/cadastrar-admin/`, {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify({
        email: email
      })
    })
  }

const listarAdministradores = (headers) => {
    return fetch(`${settings.fisioApi}/admin/cadastrar-admin/`, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
  }
  
export default {
  cadastrarSmartlock,
  PegarRelatorio,
  verificarAdmin,
  cadastrarEspecialidade,
  listarEspecialidades,
  cadastrarAdministrador,
  listarAdministradores
}